import { useState } from "react";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import { Helmet } from "react-helmet-async";
import LoansView from "./view/LoansView";
import { useSearchParams } from "react-router-dom";
import { DeductionsAndLoansTabColumns } from "../../../components/custom_tab/tabColumns";
import ExplicitDeductionsView from "./view/ExplicitDeductionsView";
import { 
	PermissionChecker, 
	PERMISSIONS, 
	useCheckUserPermissions, 
	useValidateUserPermissions 
} from "../../../helpers/usePermissionManager";

const DeductionAndLoans = () => {
	const hasPermission = useValidateUserPermissions(
		[PERMISSIONS.COMPANY_CONFIGS_WRITE, PERMISSIONS.COMPANY_CONFIGS_READ, PERMISSIONS.LOANS_WRITE, PERMISSIONS.LOANS_READ], 
		"OR"
	);
	const { checkUserPermissionsOr } = useCheckUserPermissions();
	const [searchParams, setSearchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || (
			!checkUserPermissionsOr([PERMISSIONS.COMPANY_CONFIGS_WRITE, PERMISSIONS.COMPANY_CONFIGS_READ])
			? "loans"
			: "explicitDeductions"
		)
	);

	const changeView = (item: any) => {
		setView(item.view);
		setSearchParams({ view: item.view });
	};
	
	return (hasPermission &&
		<PayrollCompanyLayout>
			<Helmet>
				<title>Deductions and Loans | Company Flow</title>
			</Helmet>
			<h1 className="font-bold text-xl mb-8">Deductions and Loans</h1>
			<div className="flex flex-col">
				<div className="flex space-x-6 border-b overflow-auto children-scroll-bar whitespace-nowrap w-full mobile-full-width max-lg:pl-4">
					{DeductionsAndLoansTabColumns.map((item, index) => (
						<PermissionChecker 
							key={index}
							permissionRule="OR" 
							permissions={
								item.view === "loans" 
									? [PERMISSIONS.LOANS_WRITE, PERMISSIONS.LOANS_READ] 
									: [PERMISSIONS.COMPANY_CONFIGS_WRITE, PERMISSIONS.COMPANY_CONFIGS_READ]
							}
						>
							<button
								onClick={() => changeView(item)}
								className={`flex pb-3 max-lg:text-sm ${
									view === item.view
										? "border-b-2 border-primary-mango text-charcoal"
										: "text-gray-400"
								}`}
							>
								{item.name}
							</button>
						</PermissionChecker>
					))}
				</div>
			</div>
			{view === "explicitDeductions" && <ExplicitDeductionsView />}
			{view === "loans" && <LoansView />}
		</PayrollCompanyLayout>
	);
};

export default DeductionAndLoans;
